'use client'

import { Button } from '@/shared/ui/button'
import { Link } from '@/shared/i18n'

export default function Error() {
  return (
    <div className={'w-full h-full grow flex flex-col items-center justify-center gap-6 px-12'}>
      <h2>This page could not be found</h2>
      <Button asChild variant={'secondary'} className={'w-full max-w-sm'}>
        <Link href="/">Return Home</Link>
      </Button>
    </div>
  )
}
